// extracted by mini-css-extract-plugin
module.exports = {"block":"PostCard_block__aTy7_","cover":"PostCard_cover__zafW7","title":"PostCard_title__AqusM","text":"PostCard_text__WGJk1","info":"PostCard_info__eEW0g"};